module.exports = __webpack_public_path__ + "img/xmzs.e1bf1348.png";